import React, { useEffect, useMemo, useState } from "react";
import "./CustomerFeedback.css";

// Add more athletes later by appending objects to this array.
const testimonialsSeed = [
  {
    id: "aushik",
    name: "Aushik Srinivas",
    level: "Ranji Trophy & TNPL",
    sport: "Cricketer",
    photoUrl: "/testimonials/aushik.png", // put image in: frontend/public/testimonials/aushik.png
    quote:
      "“Vevek is one of the better mentors around for improving your game holistically; he changed the way I trained and performed.”",
  },

  {
    id: "aadityaB",
    name: "Aaditya B",
    level: "TNPL & 1st Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/aaditya.png",
    quote:
      "“I was wearing glasses while playing before, the program helped me remove dependancy on my glasses forever!”",
  },

    {
    id: "mihir",
    name: "Mihir Ravi",
    level: "TNPL & 1st Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/mihir.png",
    quote:
      "“You can ask Vevek anything about training and performance, he is very helpful and responsive.”",
  },

  {
    id: "aniroudh",
    name: "Aniroudh Baskaran",
    level: "2nd Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/aniroudh.png",
    quote:
      "“I have been using Vevek's training program for over 3 years now and it has completely transformed my game.”",
  },

  {
    id: "ashwintg",
    name: "Ashwin Narayanan TG",
    level: "3rd Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/ashwin.png",
    quote:
      "“We have been using Vevek's approach for warm up, visualization and in-game routines, it works really well for us!”",
  },

  {
    id: "rajiv",
    name: "Rajiv Rangabhasyam",
    level: "1st Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/rajiv.png",
    quote:
      "“I was able to spot the ball better after the program, highly recommended for all athletes”",
  },
];



export default function CustomerFeedback() {
  const testimonials = useMemo(() => testimonialsSeed, []);
  const [index, setIndex] = useState(0);

  // Auto-rotate (every 6s). Remove this useEffect if you want manual-only.
  useEffect(() => {
    if (testimonials.length <= 1) return;
    const t = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(t);
  }, [testimonials.length]);

  const t = testimonials[index];

  const prev = () =>
    setIndex((i) => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setIndex((i) => (i + 1) % testimonials.length);

  return (
    <section className="v2-section">
      <div className="v2-container">
        <div className="cf-wrap">
          <div className="cf-header">
            <h2 className="cf-title">Player Feedback</h2>

            <div className="cf-controls">
              <button
                className="cf-btn"
                onClick={prev}
                disabled={testimonials.length <= 1}
                aria-label="Previous testimonial"
                type="button"
              >
                ‹
              </button>
              <button
                className="cf-btn"
                onClick={next}
                disabled={testimonials.length <= 1}
                aria-label="Next testimonial"
                type="button"
              >
                ›
              </button>
            </div>
          </div>

          <div className="cf-card">
            <div className="cf-left">
              <div className="cf-photo">
                <img
                  src={t.photoUrl}
                  alt={t.name}
                  onError={(e) => {
                    // If the image path is wrong, hide the img but keep the placeholder box.
                    e.currentTarget.style.display = "none";
                  }}
                />
              </div>

              <div className="cf-name">{t.name}</div>
              <div className="cf-meta">
                <div className="cf-level">{t.level}</div>
                <div className="cf-sport">{t.sport}</div>
              </div>
            </div>

            <div className="cf-right">
              <div className="cf-quoteMark">“</div>
              <p className="cf-quote">{t.quote}</p>
              <div className="cf-quoteMark cf-quoteMarkBottom">”</div>
            </div>
          </div>

          {/* Dots appear only when you have multiple athletes */}
          {testimonials.length > 1 && (
            <div className="cf-dots">
              {testimonials.map((x, i) => (
                <button
                  key={x.id}
                  className={`cf-dot ${i === index ? "active" : ""}`}
                  onClick={() => setIndex(i)}
                  aria-label={`Go to testimonial ${i + 1}`}
                  type="button"
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
